import React from 'react'
import { Fab, Tooltip, Box } from '@mui/material'
import { KeyboardArrowLeft } from '@mui/icons-material'
import { putAwayActions } from '../../actions/putAwayActions'
import { usePutAway } from '../../Context/usePutAway'

export default function StepBackPutAway() {
  const { validateStepBack } = putAwayActions()
  const { state } = usePutAway()
  const { step, workOrderInboundLocate } = state

  return (
    <Box
      component='div'
      display='flex'
      flexDirection='row'
      flexWrap='nowrap'
      alignItems='left'
      width='10%'
      alignSelf='start'
    >
      <Tooltip title='Volver' aria-label='back'>
        <Fab
          onClick={() => validateStepBack(step, workOrderInboundLocate)}
          aria-label='Regresar'
          style={{
            position: 'absolute',
            borderRadius: '50%',
            height: '40px',
            width: '40px',
            minWidth: '40px',
            minHeight: '40px',
            zIndex: 1
          }}
        >
          <KeyboardArrowLeft />
        </Fab>
      </Tooltip>
    </Box>
  )
}
